import { useEffect, useState } from 'react';

/**
 * Hook that returns `true` only when both a specified timeout has elapsed
 * AND the provided condition is `true`.
 *
 * @param condition - The boolean condition to evaluate.
 * @param timeout - The delay in milliseconds before the condition can return `true`.
 * @returns Returns `true` if both the timeout has passed and the condition is `true`; otherwise, returns `false`.
 */
export function useDelayedCondition(condition: boolean, timeout: number): boolean {
  const [timeoutPassed, setTimeoutPassed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutPassed(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  return timeoutPassed && condition;
}
